import React from 'react';
import { StyledAtomicButton } from './AddCartButtonContainer.styled';

const AddCartButton = ({
    children,
    variant = 'none',
    size = 'medium',
    disabled = false,
    loading = false,
    width,
    height,
    backgroundColor,
    color,
    border,
    borderRadius,
    boxShadow,
    margin,
    padding,
    fontSize,
    fontFamily,
    fontWeight,
    visibility,
    opacity,
    onClick,
    className = '',
    type = 'button',
    style = {},
    ariaLabel,
    ariaPressed,
    testId,
    marginLeft,
    ...rest
}) => {
    const handleClick = (event) => {
        if (!disabled && !loading && onClick) {
            onClick(event);
        }
    };

    return (
        <StyledAtomicButton
            variant={variant}
            size={size}
            disabled={disabled}
            loading={loading}
            width={width}
            height={height}
            backgroundColor={backgroundColor}
            color={color}
            border={border}
            borderRadius={borderRadius}
            boxShadow={boxShadow}
            margin={margin}
            padding={padding}
            fontSize={fontSize}
            fontFamily={fontFamily}
            fontWeight={fontWeight}
            visibility={visibility}
            opacity={opacity}
            className={`${className} ${disabled ? 'disabled' : ''} ${loading ? 'loading' : ''}`}
            type={type}
            style={style}
            onClick={handleClick}
            aria-label={ariaLabel}
            aria-pressed={ariaPressed}
            data-testid={testId}
            marginLeft={marginLeft}
            {...rest}
        >
            {children}
        </StyledAtomicButton>
    );
};

export default AddCartButton;
